import classnames from "classnames";
import React, { useEffect } from "react";
import Modal from "react-modal";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import styles from "./generic-modal.css";

interface GenericModalProps {
    children: JSX.Element;
    isOpen: boolean;
    onAfterOpen?: () => void;
    onClose: () => void;
    className?: string;
    noScroll?: boolean;
    fullscreen?: boolean;
}

function GenericModal({
    children,
    isOpen,
    onAfterOpen,
    onClose,
    className,
    noScroll = true,
    fullscreen = false,
}: GenericModalProps): null | JSX.Element {
    let appElement: HTMLElement | undefined;
    if (document.body) {
        appElement = document.body.querySelector<HTMLDivElement>(".site-wrapper") || undefined;
    }

    useEffect(() => {
        if (noScroll) {
            document.body.classList.toggle("no-scroll", isOpen);
            return (): void => {
                document.body.classList.remove("no-scroll");
            };
        }
    }, [isOpen, noScroll]);

    return (
        <Modal
            appElement={appElement}
            className={classnames(styles.modal, className, { [styles.fullscreen]: fullscreen })}
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onClose}
            overlayClassName={styles.overlay}
        >
            <div className={styles.closeContainer}>
                <CloseButton onClick={onClose} />
            </div>
            {children}
        </Modal>
    );
}

export default GenericModal;
